/**
 * Use an "index" exporter to make "import" paths cleaner; we can then "import" named Providers with a single import statement elsewhere in the app.
 */

export { default as DefaultTableProvider } from './DefaultTableProvider';
export { default as DefaultTableModalProvider } from './DefaultTableModalProvider';
export { default as LadderTableProvider } from './LadderTableProvider';
export { default as PlayerStatsTableProvider } from './PlayerStatsTableProvider';
